exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1IEv_6loct_99WvZddCL0q{height:100%;min-height:0;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto}html[dir] .EHd4A1RSA56idtVpEo4Rm{padding:0;-webkit-box-shadow:0 17px 0 -16px var(--neutralLight);box-shadow:0 17px 0 -16px var(--neutralLight)}", ""]);
// Exports
exports.locals = {
	"wrapper": "_1IEv_6loct_99WvZddCL0q",
	"shimmerItemWrapper": "EHd4A1RSA56idtVpEo4Rm"
};